<div *ngIf="PopupName == 'Create Survey'">
  <div class="cardLayout">
    <ion-row>
      <ion-col size="12">
        <div class="popup-heading">
          <div>
            <p class="fs-16 fs_14ForMobile font_bold cl-black">Employee Satisfaction Survey</p>
          </div>
          <div class="popup-close">
            <span [mat-dialog-close] class="ml-35 ml-sm-15 mr-5 fs-20 material-icons popup-close-icon">close</span>
          </div>
        </div>
      </ion-col>
    </ion-row>
  </div>
  <div class="cardBox">
    <form [formGroup]="createSurveyForm">
      <ion-row>
        <ion-col size-sm="12" size-md="4" size-lg="4" size-xs="12">
          <div class="formLabelSemiBoldfs14 mb-5">Survey</div>
          <mat-form-field class="w-80 mat-height40 mat-input-style mt-10">
            <input matInput type="text" formControlName="essName" placeholder="Type text here"  (keyup)="checkMaxLength(createSurveyForm.get('essName')?.value)"   maxlength="255">
            <mat-error *ngIf="createSurveyForm.controls['essName']?.hasError('required')">Survey is required</mat-error>
          </mat-form-field>
        </ion-col>
        <ion-col size-sm="12" size-md="4" size-lg="4" size-xs="12">
          <div class="formLabelSemiBoldfs14 mb-5">Start Date</div>
          <mat-form-field class="w-80 mat-height40 mat-input-style mt-10">
            <input readonly matInput dateInput [matDatepicker]="surveyStartDate" placeholder="DD/MM/YYYY"
              formControlName="startDate" [min]="minDate" [matDatepickerFilter]="dateFilter">
            <mat-datepicker-toggle matIconSuffix [for]="surveyStartDate"></mat-datepicker-toggle>
            <mat-datepicker #surveyStartDate></mat-datepicker>
            <mat-error *ngIf="createSurveyForm.controls['startDate']?.hasError('required')">Start Date is
              required</mat-error>
          </mat-form-field>
        </ion-col>
        <ion-col size-sm="12" size-md="4" size-lg="4" size-xs="12">
          <div class="formLabelSemiBoldfs14 mb-5">End Date</div>
          <mat-form-field class="w-80 mat-height40 mat-input-style mt-10">
            <input readonly matInput dateInput [matDatepicker]="surveyEndDate" placeholder="DD/MM/YYYY"
              formControlName="endDate" [min]="createSurveyForm.value.startDate" [matDatepickerFilter]="dateFilter">
            <mat-datepicker-toggle matIconSuffix [for]="surveyEndDate"></mat-datepicker-toggle>
            <mat-datepicker #surveyEndDate></mat-datepicker>
            <mat-error *ngIf="createSurveyForm.controls['endDate']?.hasError('required')">End Date is
              required</mat-error>
          </mat-form-field>
        </ion-col>
      </ion-row>

      <ion-row>
        <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
          <div>
            <button (click)="createSurvey()" type="button" class="add_btn fs-14 fs_12ForMobile center-content mr-5 mt-10"
              [style.background-color]="buttonColorName">Create New ESS</button>
          </div>
        </ion-col>
      </ion-row>
    </form>
  </div>
</div>

<div *ngIf="PopupName == 'View Employees'">
  <div class="cardLayout">
    <ion-row>
      <ion-col size="12">
        <div class="popup-heading">
          <div>
            <p *ngIf="moduleName == 'ESS'" class="fs-16 fs_14ForMobile font_bold cl-black">Employee Satisfaction Survey</p>
            <p *ngIf="moduleName == '360'" class="fs-16 fs_14ForMobile font_bold cl-black">360 Review Employees</p>
          </div>
          <div class="popup-close">
            <span (click)="onClickSaveViewEmp()" class="ml-35 ml-sm-15 mr-5 fs-20 material-icons popup-close-icon">close</span>
          </div>
        </div>
      </ion-col>
    </ion-row>
  </div>
  <div class="cardBox">
    <ion-row>
      <ion-col size-sm="6" size-md="6" size-lg="6" size-xs="6">
        <div class="d-flex">
          <mat-form-field class="mat-height40 mat-input-style">
            <mat-icon matPrefix>search</mat-icon>
            <input matInput type="search" placeholder="Search" [(ngModel)]="searchString"
              (input)="onSearchInput($event)">
          </mat-form-field>

          <!-- <ion-label class="center-content ml-10 fs-14 fs_12ForMobile font_medium pr-10 black_color">Show</ion-label>
          <mat-form-field class="w70px mat-height40 mat-input-style">
            <mat-select placeholder="Select">
              <mat-option value="25">25</mat-option>
              <mat-option value="50">50</mat-option>
              <mat-option value="75">75</mat-option>
              <mat-option value="100">100</mat-option>
            </mat-select>
          </mat-form-field>
          <ion-label class="center-content fs-14 fs_12ForMobile font_medium pl-10 black_color">entries</ion-label> -->
        </div>
      </ion-col>
      <ion-col size-sm="6" size-md="6" size-lg="6" size-xs="6">
        <div class="verticle-center float-right">
          <div>
            <button (click)="exportEssEmployee()" type="button" class="export_btn fs-14 fs_12ForMobile center-content mr-10">
              <img class="mr-5" src="././assets/icon/export.svg">Export</button>
          </div>
          <div>
            <button *ngIf="!isPublished" type="button" class="save_btn" [style.background-color]="buttonColorName"
              (click)="onClickSaveViewEmp()">Save</button>
          </div>
        </div>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col size="12">
        <!-- <ag-grid-angular
          style="width: 100%; height: 500px;"
          class="ag-theme-alpine"
          [rowData]="listOfEmployees"
          [columnDefs]="arrViewEmployeecolumnDefs"
          rowSelection="multiple"
          (selectionChanged)="onSelectionChanged($event)">
        </ag-grid-angular> -->
        <!-- <ag-grid-angular
        style="width: 100%; height: 500px;"
        class="ag-theme-quartz"
        [rowData]="listOfEmployees"
        [columnDefs]="arrViewEmployeecolumnDefs"
        rowSelection="multiple"
        [suppressRowClickSelection]="true"
        (gridReady)="onGridReady($event)"
        (selectionChanged)="onSelectionChanged($event)">
      </ag-grid-angular> -->
        <div class="table-container">
          <table>
            <thead>
              <tr>
                <th class="fs-14 fs_12ForMobile font_bold cl-black">
                  <section class="mat-checkbox-style">
                    <mat-checkbox [(ngModel)]="isAllEmployeeSelected" class="fs-12 font_semibold "
                      (change)="onSelectAllEmployee($event)" [checked]="isAllEmployeeSelected" value="true"
                      (click)="$event.stopPropagation()" value=true><span class="fs-14 fs_12ForMobile font_bold cl-black">Emp.
                        Id.</span></mat-checkbox>
                  </section>
                </th>
                <th class="fs-14 fs_12ForMobile font_bold cl-black">
                  First Name
                </th>
                <th class="fs-14 fs_12ForMobile font_bold cl-black">
                  Last Name
                </th>
                <th class="fs-14 fs_12ForMobile font_bold cl-black">
                  DOJ
                </th>
                <th class="fs-14 fs_12ForMobile font_bold cl-black">
                  Designation
                </th>
                <th class="fs-14 fs_12ForMobile font_bold cl-black">
                  Department
                </th>
                <th class="fs-14 fs_12ForMobile font_bold cl-black">
                  Manager
                </th>
                <th class="fs-14 fs_12ForMobile font_bold cl-black">
                  Location
                </th>
                <th class="fs-14 fs_12ForMobile font_bold cl-black">
                  Band
                </th>
                <th class="fs-14 fs_12ForMobile font_bold cl-black">
                  Grade
                </th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of listOfEmployees;let i=index">
                <td>
                  <section class="mat-checkbox-style">
                    <mat-checkbox [(ngModel)]="item.isChecked" class="fs-12 font_semibold "
                      (change)="onSelectSingleEmployee($event,item,i)" [checked]="item.isChecked" value="true"
                      (click)="$event.stopPropagation()" value=true>{{item.employeeId}}</mat-checkbox>
                  </section>
                </td>
                <td class="fs-14 fs_12ForMobile font_regular">{{item.firstName}}</td>
                <td class="fs-14 fs_12ForMobile font_regular">{{item.lastName}}</td>
                <td class="fs-14 fs_12ForMobile font_regular">{{item.dateOfJoining | date:'dd-MM-yyyy'}}</td>
                <td class="fs-14 fs_12ForMobile font_regular">{{item.designation}}</td>
                <td class="fs-14 fs_12ForMobile font_regular">{{item.department}}</td>
                <td class="fs-14 fs_12ForMobile font_regular">{{item.reportingManagerName}}</td>
                <td class="fs-14 fs_12ForMobile font_regular">{{item.officeLocation}}</td>
                <td class="fs-14 fs_12ForMobile font_regular">{{item.band}}</td>
                <td class="fs-14 fs_12ForMobile font_regular">{{item.grade}}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col>
        <div>
          <!-- <div class="fs-14 fs_12ForMobile font_bold black_color">Showing 1 to 25 entries</div> -->
        </div>
      </ion-col>
    </ion-row>
  </div>
</div>

<div *ngIf="PopupName == 'Create Email Body'">
  <div class="cardLayoutTwo">
    <ion-row>
      <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
        <div class="popup-heading">
          <div class="verticle-center">
            <p class="fs-16 fs_14ForMobile font_regular">{{getPopupName}}</p>
          </div>
          <div class="popup-close">
            <span (click)="onClickCloseInvitation()"
              class="ml-35 ml-sm-15 mr-5 fs-30 material-icons popup-close-icon">close</span>
          </div>
        </div>
      </ion-col>
    </ion-row>

    <div class="cardBoxTwo">
      <ion-row class="verticle-center mt-10">
        <ion-col size-sm="12" size-md="1" size-lg="1" size-xs="12">
          <div class="fs-16 fs_14ForMobile font_semibold">Subject:</div>
        </ion-col>

        <ion-col size-sm="12" size-md="9" size-lg="9" size-xs="12">
          <mat-form-field class="w-100 mat-height40 mat-input-style pl-10">
            <input matInput type="text" [(ngModel)]="invitationEmailSubject" placeholder="Enter Subject Here...">
          </mat-form-field>
        </ion-col>

        <ion-col size-sm="12" size-md="2" size-lg="2" size-xs="12">
          <button *ngIf="!isPublished" (click)="onClickSaveInvitation()" type="button"
            class="add_btn fs-14 fs_12ForMobile float-right center-content" [style.background-color]="buttonColorName">
            <span class="material-icons fs-16 fs_14ForMobile mr-5">send</span>
            Save
          </button>
        </ion-col>
      </ion-row>

      <ion-row class="verticle-center mt-10">
        <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
          <div>
            <!-- <angular-editor id="htmlDiv" [config]="editorConfig" [(ngModel)]="invitationEmailBody"></angular-editor> -->
            <jodit-editor id="htmlDiv" *ngIf="isEditorReady()" [config]="editorConfig"
              [(ngModel)]="invitationEmailBody"></jodit-editor>

          </div>
        </ion-col>
      </ion-row>
    </div>
  </div>
</div>

<div *ngIf="PopupName == 'Create Instructions'">
  <div class="cardLayoutTwo">
    <ion-row>
      <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
        <div class="popup-heading">
          <div class="verticle-center">
            <p *ngIf="moduleName == 'ESS'" class="fs-16 fs_14ForMobile font_bold cl-black">Survey Instructions</p>
            <p *ngIf="moduleName == '360'" class="fs-16 fs_14ForMobile font_bold cl-black">360 Review Instructions</p>
          </div>
          <div class="popup-close">
            <span (click)="onClickCloseInstruction()"
              class="ml-35 ml-sm-15 mr-5 fs-30 material-icons popup-close-icon">close</span>
          </div>
        </div>
      </ion-col>
    </ion-row>

    <div class="cardBoxTwo">
      <ion-row>
        <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
          <div class="fs-16 fs_14ForMobile">Add instructions</div>
          <ion-row *ngIf="!isPublished">
            <ion-col size-sm="12" size-md="6" size-lg="6" size-xs="12">
              <mat-form-field class="custom-input w-100 mat-input-style">
                <textarea matInput maxlength="255" placeholder="Type Here..." rows="5"
                  [(ngModel)]="instructionName"></textarea>
              </mat-form-field>
              <div class="fs-12 red mt-10" *ngIf="isInstructionPresent">Instruction already exists!</div>
              <!-- <div class="fs-14 fs_12ForMobile mt-5">Keep your description under 255 characters.</div> -->
            </ion-col>
            <ion-col size-sm="12" size-md="6" size-lg="6" size-xs="12">
              <button *ngIf="!isPublished" type="button" (click)="onClickAddInstruction()" class="save_btn"
                [style.background-color]="buttonColorName">Add</button>
            </ion-col>
          </ion-row>
          <ion-row *ngIf="intructionList.length!=0">
            <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
              <div class="table-container mt-20">
                <table>
                  <thead>
                    <tr>
                      <th class="fs-14 fs_12ForMobile font_bold cl-black">
                        Instructions
                      </th>
                      <th *ngIf="!isPublished" class="fs-14 fs_12ForMobile font_bold cl-black">
                        Action
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let item of intructionList;let i=index">
                      <td>{{item}}</td>
                      <td *ngIf="!isPublished">
                        <img src="././assets/icon/red_delete.svg" alt="Delete" (click)="onClickRemoveInstruction(i)">
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </ion-col>
          </ion-row>
          <ion-row *ngIf="intructionList.length!=0 && !isPublished">
            <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
              <button type="button" (click)="onClickSaveInstruction()" class="save_btn mt-20"
                [style.background-color]="buttonColorName">Save</button>
            </ion-col>
          </ion-row>
        </ion-col>
      </ion-row>
    </div>
  </div>
</div>

<div *ngIf="PopupName == 'Submission Email'">
  <div class="cardLayoutTwo">
    <ion-row>
      <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
        <div class="popup-heading">
          <div class="verticle-center">
            <p class="fs-16 fs_14ForMobile font_regular">Submission Email</p>
          </div>
          <div class="popup-close">
            <span (click)="onClickCloseSubmission()"
              class="ml-35 ml-sm-15 mr-5 fs-30 material-icons popup-close-icon">close</span>
          </div>
        </div>
      </ion-col>
    </ion-row>

    <div class="cardBoxTwo">
      <ion-row class="verticle-center mt-10">
        <ion-col size-sm="12" size-md="1" size-lg="1" size-xs="12">
          <div class="fs-16 fs_14ForMobile font_semibold">Subject:</div>
        </ion-col>

        <ion-col size-sm="12" size-md="9" size-lg="9" size-xs="12">
          <mat-form-field class="w-100 mat-height40 mat-input-style pl-10">
            <input matInput type="text" [(ngModel)]="submissionEmailSubject" placeholder="Enter Subject Here...">
          </mat-form-field>
        </ion-col>

        <ion-col size-sm="12" size-md="2" size-lg="2" size-xs="12">
          <button *ngIf="!isPublished" (click)="onClickSaveSubmission()" type="button"
            class="add_btn fs-14 fs_12ForMobile float-right center-content" [style.background-color]="buttonColorName">
            <span class="material-icons fs-16 fs_14ForMobile mr-5">send</span>
            Save
          </button>
        </ion-col>
      </ion-row>

      <ion-row class="verticle-center mt-10">
        <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
          <div>
            <!-- <angular-editor id="htmlDiv" [config]="editorConfig" [(ngModel)]="submissionEmailBody"></angular-editor> -->
            <jodit-editor *ngIf="editorConfig && submissionEmailBody!=undefined" [(ngModel)]="submissionEmailBody" [config]="editorConfig"
              [ngModelOptions]="{ standalone: true }" id="htmlDiv">
            </jodit-editor>

          </div>
        </ion-col>
      </ion-row>
    </div>
  </div>
</div>

<div class="container1" [style.background-color]="selectedtemplateBgColor" *ngIf="PopupName == 'My Master'" >
  <div class="pl-20 pr-20 pt-20 pb-0">
    <div class="popup-heading">
      <div class="verticle-center">
        <!-- <p class="fs-16 fs_14ForMobile font_regular">Submission Email</p> -->
      </div>
      <div class="popup-close">
        <button class="download-btn" (click)="onClickDownloadGraphAsPdf('activeessReview')">
          <span class="ml-5 mr-5 fs-12 material-icons">arrow_downward</span>
          <span *ngIf="!mobileResponsiveService.hideForTabletAndBelow">Download</span>
        </button>
        <span [mat-dialog-close] class="ml-35 ml-sm-15 mr-5 fs-26 material-icons popup-close-icon">close</span>
      </div>
    </div>
  </div>
  <div id="activeessReview">
    <div class="pl-20 pr-20 pt-20 pb-0">
      <div class="headingOfShowBox_two font_medium fs-14 fs_12ForMobile" [style.background-color]="selectedTemplateColorCode">
        <ion-row class="p-0">
          <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
            <div class="display-space-between">
              <div class="font_bold fs-14 fs_12ForMobile">Employee Satisfaction Survey</div>
              <div class="verticle-center">
                <div class="verticle-center mr-20">
                  <!-- <img class="w30" src="././assets/icon/mail_white_icon.svg" alt="createEmailBody"> -->
                  <!-- <p class="ml-5">Samplename123&#64;gmail.com</p> -->
                </div>
                <div class="icon-container">
                  <span class="material-icons mr-10 fs-16 fs_14ForMobile">info</span>
                  <div class="tooltip">
                    <div class="info-popup">
                      <div class="p-20">
                        <h4 class="font_semibold">Instructions</h4>
                        <div class="mt-10 ml-20">
                          <ul *ngFor="let data of intructionList">
                            <li class="fs-12 text_gray text-wrap">{{data}}</li>
                          </ul>
                        </div>
                        <div class="info-table mt-20">
                          <table>
                            <thead>
                              <tr>
                                <th>Question type</th>
                                <th>Rating</th>
                                <th>Rating Definition</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr *ngFor="let item of ratingList">
                                <td>{{item.questionType}}</td>
                                <td>{{item.rating}}</td>
                                <td>{{item.ratingDefinition}}</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ion-col>
        </ion-row>
      </div>
      <div class="cardBox_one p-10">
        <ion-row>
          <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
            <ion-row>
              <ion-col size-sm="12" size-md="3" size-lg="3" size-xs="12">
                <div class="formLabelSemiBoldfs14 mb-5">Year</div>
                <mat-form-field class="w-90 mat-height40 mat-input-style">
                  <input [attr.readonly]="isFieldsDisabled ? false: true" [disabled]="isFieldsDisabled" readonly
                    [ngClass]="{'notAllowed' : isFieldsDisabled}" matInput [(ngModel)]="myMasterSelectedYear"
                    placeholder="Type text here" class="font_regular">
                </mat-form-field>
              </ion-col>
              <ion-col size-sm="12" size-md="3" size-lg="3" size-xs="12">
                <div class="formLabelSemiBoldfs14 mb-5">Survey</div>
                <div 
                class="w-90 inputBoxDisabled opacity5"
                [matTooltip]="selectedSurveyName"
                matTooltipClass="custom-tooltip"
                matTooltipPosition="above">
                
                {{ selectedSurveyName?.length > 15 
                  ? (selectedSurveyName | slice:0:15) + '...' 
                  : selectedSurveyName }}
              </div>
              </ion-col>
              <ion-col size-sm="12" size-md="3" size-lg="3" size-xs="12">
                <div class="formLabelSemiBoldfs14 mb-5">Start date</div>
                <div class="w-90 inputBoxDisabled opacity5">
                  {{selectedSurveyStartDate | date:'dd-MM-yyyy'}}
                </div>
              </ion-col>
              <ion-col size-sm="12" size-md="3" size-lg="3" size-xs="12">
                <div class="formLabelSemiBoldfs14 mb-5">End date</div>
                <div class="w-90 inputBoxDisabled opacity5">
                  {{selectedSurveyEndDate | date:'dd-MM-yyyy'}}
                </div>
              </ion-col>
            </ion-row>
          </ion-col>
        </ion-row>
      </div>
    </div>

    <div class="mb-20 pr-30 pl-30 pt-0 mt-20" *ngIf="selectedSurveyName!=null" id="downloadTable">
      <div class="">
        <div class="fs-24 fs_18ForMobile font_regular">{{selectedSurveyName}}</div>
        <div class="cardBox_two mt-20" *ngFor="let item of mySurveyQuestionList;let i =index">
          <div class="headingOfShowBox_two font_medium fs-14 fs_12ForMobile" [style.background-color]="selectedTemplateColorCode">
          </div>
          <div class="p-20">
            <div class="fs-14 fs_12ForMobile font_regular">{{item.question}}</div>
            <div class="mt-10" *ngIf="item.questionType == 'Open Ended'">
              <mat-form-field class="custom-input w-100 mat-height40 mat-input-style">
                <textarea readonly matInput placeholder="Enter your Answer" rows="1"
                  [(ngModel)]="item.answer"></textarea>
              </mat-form-field>
            </div>
            <div class="mt-10 essRatingBaseQuestion" *ngIf="item.questionType == 'Rating Based'">
              <div class="ml-10" *ngFor="let data of ratingListOnRatingBased; let j = index;let isLast=last">
                <div class="rating_btn w100 cp" [ngClass]="{'selectedAnswer': item.answer == data.rating}">{{
                  data.rating }}</div>
                  <div class="text-center fs-12 mt-5 text_gray"
                  *ngIf="j==0 || isLast || item.answer == data.rating"
                  [matTooltip]="data?.ratingDefinition"
                  matTooltipClass="custom-tooltip"
                  matTooltipPosition="above">
                  {{ data?.ratingDefinition?.length > 15 
                   ? (data?.ratingDefinition | slice:0:15) + '...' 
                   : data?.ratingDefinition }}
                  </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="container" [style.background-color]="selectedtemplateBgColor" *ngIf="PopupName == '360 Review'">
  <div class="pl-20 pr-20 pt-20 pb-0">
    <div class="popup-heading">
      <div class="verticle-center">
        <!-- <p class="fs-16 fs_14ForMobile font_regular">Submission Email</p> -->
      </div>
      <div class="popup-close">
        <button class="download-btn" (click)="onClickDownloadGraphAsPdf('active360Review')">
          <span class="ml-5 mr-5 fs-12 material-icons">arrow_downward</span>
          <span *ngIf="!mobileResponsiveService.hideForTabletAndBelow">Download</span>
        </button>
        <span [mat-dialog-close] class="ml-35 ml-sm-15 mr-5 fs-30 material-icons popup-close-icon">close</span>
      </div>
    </div>
  </div>
  <div id="active360Review">
    <div class="pl-20 pr-20 pt-20 pb-0">
      <div class="headingOfShowBox_two font_medium fs-14 fs_12ForMobile" [style.background-color]="selectedTemplateColorCode">
        <ion-row class="p-0">
          <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
            <div class="display-space-between">
              <div class="font_bold fs-14 fs_12ForMobile">360 Review</div>
              <div class="verticle-center">
                <div class="verticle-center mr-20">
                  <!-- <img class="w30" src="././assets/icon/mail_white_icon.svg" alt="createEmailBody"> -->
                  <!-- <p class="ml-5">Samplename123&#64;gmail.com</p> -->
                </div>
                <div class="icon-container">
                  <span class="material-icons mr-10 fs-16 fs_14ForMobile">info</span>
                  <div class="tooltip">
                    <div class="info-popup">
                      <div class="p-20">
                        <h4 class="font_semibold">Instructions</h4>
                        <div class="mt-10 ml-20">
                          <ul *ngFor="let data of intructionList">
                            <li class="fs-12 text_gray">{{data}}</li>
                          </ul>
                        </div>
                        <div class="info-table mt-20">
                          <table>
                            <thead>
                              <tr>
                                <th>Question type</th>
                                <th>Rating</th>
                                <th>Rating Definition</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr *ngFor="let item of ratingList">
                                <td>{{item.questionType}}</td>
                                <td>{{item.rating}}</td>
                                <td>{{item.ratingDefinition}}</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ion-col>
        </ion-row>
      </div>
      <div class="cardBox_one p-10">
        <ion-row>
          <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
            <ion-row>
              <ion-col size-sm="12" size-md="3" size-lg="3" size-xs="12">
                <div class="formLabelSemiBoldfs14 mb-5">Year</div>
                <div class="w-90 inputBoxDisabled opacity5">
                  {{sharedService.transformYearToFyFormat(selectedYear)}}
                </div>
              </ion-col>
              <ion-col size-sm="12" size-md="3" size-lg="3" size-xs="12">
                <div class="formLabelSemiBoldfs14 mb-5">Survey</div>
                <div class="w-90 inputBoxDisabled opacity5">
                  {{selectedReviewName}}
                </div>
              </ion-col>
              <ion-col size-sm="12" size-md="3" size-lg="3" size-xs="12">
                <div class="formLabelSemiBoldfs14 mb-5">Start date</div>
                <div class="w-90 inputBoxDisabled opacity5">
                  {{selectedReviewStartDate | date:'dd-MM-yyyy'}}
                </div>
              </ion-col>
              <ion-col size-sm="12" size-md="3" size-lg="3" size-xs="12">
                <div class="formLabelSemiBoldfs14 mb-5">End date</div>
                <div class="w-90 inputBoxDisabled opacity5">
                  {{selectedReviewEndDate | date:'dd-MM-yyyy'}}
                </div>
              </ion-col>
            </ion-row>
          </ion-col>
        </ion-row>
      </div>
    </div>

    <div class="mb-20 pr-30 pl-30 pt-0 mt-20" *ngIf="selectedReviewName!=null">
      <div>
        <div class="fs-24 fs_18ForMobile font_regular mb-20">{{selectedReviewName}}</div>
        <div class="table-container">
          <table>
            <thead [style.background-color]="selectedTemplateColorCode">
              <tr>
                <th>Function</th>
                <th>Band</th>
                <th>Competancies</th>
                <th>Questions</th>
                <th>Type (open/ rating)</th>
              </tr>
            </thead>
            <tbody>
              <ng-container *ngFor="let item of getCompetencyList; let i = index">
                <tr *ngFor="let data of item.competencies; let k = index;let isLast = last">
                  <td *ngIf="k === 0" [attr.rowspan]="item.competencies.length">
                    {{ item.department }}
                  </td>
                  <td *ngIf="k === 0" [attr.rowspan]="item.competencies.length">
                    {{ item.band }}
                  </td>
                  <td>
                    <div class="verticle-center">
                      <div>
                        {{ data.competencyName }}
                      </div>
                    </div>
                  </td>
                  <td>
                    <ng-container *ngFor="let question of data.questions; let j = index;let questionLast = last">
                      <div class="verticle-center mb-5">
                        {{ question.question }}
                      </div>
                    </ng-container>
                  </td>
                  <td>
                    <ng-container *ngFor="let question of data.questions; let j = index;let questionLast = last">
                      <div class="verticle-center mb-5">
                        {{question.questionType}}
                      </div>
                    </ng-container>
                  </td>
                </tr>
              </ng-container>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>